import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/app/Home.vue'
import POS from './views/app/Pos.vue'
import Funcionarios from './views/app/Funcionarios.vue'
import HistoricoVouchers from './views/app/HistoricoVouchers.vue'
import Itens from './views/app/Itens.vue'
import MeusClientes from './views/app/MeusClientes.vue'
import Login from './views/auth/Login.vue'
import AuthHandle from './views/auth/AuthHandle'
import Pedidos from './views/app/Pedidos.vue'
import VendasPosPagas from './views/app/VendasPosPagas.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: '/',
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login
    },
    {
      path: '/auth',
      component: AuthHandle,
      props: (route) => ({
        mode: route.query.mode,
        oobCode: route.query.oobCode,
        apiKey: route.query.apiKey,
        lang: route.query.lang
      })
    },
    {
      path: '/home',
      component: Home,
      children: [
        {
          path: '',
          component: POS
        },
        {
          path: '/funcionarios',
          component: Funcionarios
        },
        {
          path: '/historico',
          component: HistoricoVouchers
        },
        {
          path: '/itens',
          component: Itens
        },
        {
          path: '/meus-clientes',
          component: MeusClientes
        },
        {
          path: '/pedidos',
          component: Pedidos
        },
        {
          path: '/vendas-pos-pagas',
          component: VendasPosPagas
        }
      ]
    }
  ]
})

export default router
